import { useEffect, useState } from "react";

export function useFlashingEffect( intervalMs = 1000 ): boolean
{
    const [ flashState, setFlashState ] = useState( true );

    useEffect( () =>
    {
        const interval = setInterval( () => setFlashState( prev => !prev ), intervalMs );
        return () => clearInterval( interval );
    }, [ intervalMs ] );

    return flashState;
}
